import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import './theme/global.css';
import { Providers } from './app/Providers';
import { createAppRouter } from './app/router';
import { ConfigError, getConfig } from './config/config';
import { loadLanguage, useLanguageStore } from './i18n/languageStore';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element in index.html');
}
const root = createRoot(container);

try {
  await loadLanguage(useLanguageStore.getState().language); // a returning Vietnamese visitor never sees English first
  getConfig(); // fail fast, with a readable message, if /config.js is missing
  const router = createAppRouter();
  root.render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  );
} catch (error) {
  root.render(
    <main style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Kindra can’t start</h1>
      <p>{error instanceof ConfigError ? error.message : 'An unexpected error occurred.'}</p>
    </main>,
  );
  throw error;
}
